export const initialState = {
  queueItems: [],
  unsubscribeReasons: [],
  activeStep: 'initial',
  activeReason: null,
  refund: null,
  isFetched: false,
  hasError: false,
  isFeedbackSent: false,
  isUnsubscribeSelected: false,
}

export const update = (state, payload) => ({
  ...state,
  ...payload,
})
